import { useContext } from 'react';
import { UserContext } from '../user.context';

export const useSession = () => {
  const { user } = useContext(UserContext);
  return { user };
}